import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/va-disability-education-hub/VADisabilityEducationHubClient.tsx");
